import {
  GetConfigSoftSkillsLevelsResponse,
  UpdateSoftSkillsLevelsConfig,
} from "../../../types/api/configurations.type";
import httpClient from "../../client/HttpClient";

const ConfigurationsSoftSkillsLevelsService = {
  async list(): Promise<GetConfigSoftSkillsLevelsResponse> {
    const response = await httpClient.get<GetConfigSoftSkillsLevelsResponse>(
      "v1/config/soft-skills/levels",
    );
    return response;
  },
  async update(body: UpdateSoftSkillsLevelsConfig): Promise<void> {
    await httpClient.patch("v1/config/soft-skills/levels", body);
  },
};

export default ConfigurationsSoftSkillsLevelsService;
